export default {
  primerSingle: "El nostre primer single:",
  nouSingle: "Nou single disponible a totes les plataformes:",
  primerEP: "Escolta el nostre primer EP:",
  iMes: "...i més",
  presave: "Pre-save",
  spotify: "Spotify",
  youtube: "Youtube",
  soundcloud: "Soundcloud",
  amazonMusic: "Amazon Music",
  appleMusic: "Apple Music",
  videoDisponible: "Videoclip disponible a Youtube:",
  contacte: "Contacte:",
  avisLegal: "Avis legal",
  politicaPrivacitat: "Política de privacitat",
  politicaCookies: "Política de cookies",
  textAvisLegal: `<h1>AVIS LEGAL</h1>
                  <p>
                    En el present Avís Legal, l'Usuari, podrà trobar tota la
                    informació relativa a les condicions legals que defineixen les relacions
                    entre els usuaris i el responsable de la pàgina web accessible en l'adreça
                    URL
                    <a class="hoverable" href="https://onesbanda.com/"
                      >https://onesbanda.com</a
                    >
                    (d'ara en avant, el lloc web), que <strong>ONES</strong> posa a la disposició de
                    els usuaris d'Internet.
                  </p>
                  <p>
                    La utilització del lloc web implica l'acceptació plena i sense reserves de
                    totes i cadascuna de les disposicions incloses en aquest Avís Legal. En
                    conseqüència, l'usuari del lloc web ha de llegir atentament el present
                    Avís Legal en cadascuna de les ocasions en què es propose utilitzar la
                    web, ja que el text podria patir modificacions a criteri del titular
                    de la web, o a causa d'un canvi legislatiu, jurisprudencial o en la
                    pràctica empresarial.
                  </p>
                  <h3><strong>Responsable:</strong></h3>
                  <p>
                    Raó Social: Vicent Mayans Roca<br />NIF: 20845345P<br />Adreça: Plaça
                    del Regne, 5, 46600 Alzira, Valencia<br />Teléfono:
                    <a class="hoverable" href="tel:+34618118469">+34 618118469</a><br />Correu
                    electrònic:
                    <a class="hoverable" href="mailto:info{'@'}onesbanda.com"
                      >info{'@'}onesbanda.com</a
                    >
                  </p>
                  <p>
                    Aquest Lloc web garanteix la protecció i confidencialitat de les dades
                    personals que ens proporcionen d'acord amb el que es disposa en el
                    Reglament General de Protecció de Dades de Caràcter Personal (UE)
                    2016/679 del Parlament Europeu.
                  </p>
                  <h3><strong>Objecte:</strong></h3>
                  <p>
                    El lloc web facilita als usuaris del mateix l'accés a informació i
                    serveis prestats per ONES a aquelles persones o organitzacions
                    interessades en aquests.
                  </p>
                  <p>
                    L'accés i la utilització del Lloc web atribueix la condició d'usuari
                    del Lloc web (d'ara en avant, el “Usuari”) i implica l'acceptació de totes
                    les condicions incloses en aquest Avís Legal així com de les seues
                    modificacions. La prestació del servei del Lloc web té una
                    duració limitada al moment en el qual l'Usuari es trobe connectat
                    al Lloc web o a algun dels serveis que a través del mateix es
                    faciliten. Per tant, l'Usuari ha de llegir atentament el present Avís
                    Legal en cadascuna de les ocasions en què es propose utilitzar el Lloc web
                    , ja que aquest i les seues condicions d'ús recollides en el present Avís
                    Legal poden patir modificacions.
                  </p>
                  <h3><strong>Accés i utilització de la web</strong>:</h3>
                  <ul>
                    <li>
                      Caràcter gratuït de l'accés i utilització de la web. L'accés a la web
                      té caràcter gratuït per als usuaris d'aquesta, excepte en el
                      relatiu al cost de la connexió a través de la xarxa de
                      telecomunicacions subministrada pel proveïdor d'accés contractat
                      pels usuaris.
                    </li>
                    <li>
                      Registre d'usuaris. Amb caràcter general l'accés i utilització de la
                      web no exigeix la prèvia subscripció o registre dels usuaris d'aquesta
                    </li>
                    <li>
                      Els usuaris garanteixen i responen, en qualsevol cas, de l'exactitud,
                      vigència i autenticitat de les dades personals facilitades, i es comprometen
                      a mantindre'ls degudament actualitzats. L'usuari accepta
                      proporcionar informació completa i correcta en el formulari de
                      contacte o subscripció.
                    </li>
                  </ul>
                  <p>
                    En cap cas es recaptaran del menor d'edat dades relatives a la
                    situació professional, econòmica o a la intimitat dels altres membres de la
                    família, sense el consentiment d'aquests. Si eres menor de tretze anys i
                    has accedit a aquest lloc web sense avisar als teus pares no has de registrar-te
                    com a usuari.
                  </p>
                  <p>
                    En aquesta web es respecten i cuiden les dades personals dels usuaris.
                    Com a usuari has de saber que els teus drets estan garantits.
                  </p>
                  <h3><strong>Continguts de la web</strong>:</h3>
                  <p>
                    L'idioma utilitzat pel titular en la web serà el valencià o el
                    castellà. <strong>ONES </strong>no es responsabilitza de la no
                    comprensió o enteniment de l'idioma de la web per l'usuari, ni de les seues
                    conseqüències.
                  </p>
                  <p>
                    <strong>ONES</strong> podrà modificar els continguts sense previ avís, així com
                    suprimir i canviar aquests dins de la web, com la forma en què s'accedeix
                    a aquests, sense cap justificació i lliurement, no
                    responsabilitzant-se de les conseqüències que els mateixos puguen ocasionar als
                    usuaris.
                  </p>
                  <p>
                    Es prohibeix l'ús dels continguts de la web per a promocionar, contractar
                    o divulgar publicitat o informació pròpia o de terceres persones sense l'autorització
                    de <strong>ONES</strong>, ni remetre publicitat o informació
                    valent-se per a això dels serveis o informació que es posen a la disposició de
                    els usuaris, independentment de si la utilització és
                    gratuïta o no.
                  </p>
                  <p>
                    Els enllaços que incorporen tercers en les seues pàgines web,
                    dirigits a aquesta web, seran per a l'obertura de la pàgina web completa, no
                    podent manifestar, directament o indirectament, indicacions falses,
                    inexactes o confuses, ni incórrer en accions deslleials o il·lícites en
                    contra d'<strong>ONES.</strong>
                  </p>
                  <h3><strong>Mesures de seguretat:</strong></h3>
                  <p>
                    Les dades personals comunicats per l'usuari podran ser emmagatzemats en
                    bases de dades automatitzades o no, la titularitat de les quals correspon en
                    exclusiva a <strong>ONES</strong>, assumint totes les mesures d'índole
                    tècnica, organitzativa i de seguretat que garantisquen la confidencialitat,
                    integritat i qualitat de la informació continguda en les mateixes d'acord
                    amb el que s'estableix en les normatives vigents en matèria de protecció de
                    dades de caràcter personal.
                  </p>
                  <h3><strong>Limitació de responsabilitat:</strong></h3>
                  <p>
                    Tant l'accés a la web com l'ús no consentit que puga efectuar-se de la
                    informació continguda en la mateixa és de l'exclusiva responsabilitat de
                    qui el realitza. <strong>ONES</strong> no respondrà de cap
                    conseqüència, mal o perjudici que pogueren derivar-se d'aquest accés o
                    ús. <strong>ONES</strong> no es fa responsable dels errors de
                    seguretat, que es puguen produir ni dels danys que puguen causar-se al
                    sistema informàtic de l'usuari (maquinari i programari), o als fitxers o
                    documents emmagatzemats en aquest, a conseqüència de:
                  </p>
                  <ul>
                    <li>
                      la presència d'un virus en l'ordinador de l'usuari que siga utilitzat
                      per a la connexió als serveis i continguts de la web.
                    </li>
                    <li>un mal funcionament del navegador.</li>
                    <li>i/o de l'ús de versions no actualitzades d'aquest.</li>
                  </ul>
                  <p>
                    <strong>ONES</strong> no es fa responsable de la fiabilitat i rapidesa dels
                    enllaços que s'incorporen en la web per a l'obertura d'unes altres.
                    <strong>ONES</strong> no garanteix la utilitat d'aquests enllaços, ni es
                    responsabilitza dels continguts o serveis als quals puga accedir l'usuari
                    per mitjà d'aquests enllaços, ni del bon funcionament d'aquestes
                    webs.
                  </p>
                  <p>
                    <strong>ONES</strong> no serà responsable dels virus o altres programes
                    informàtics que deterioren o puguen deteriorar els sistemes o equips
                    informàtics dels usuaris en accedir al seu web o altres webs a les quals s'haja
                    accedit mitjançant enllaços d'aquesta web.
                  </p>
                  <h3><strong>Ús de la tecnologia «Cookie»:</strong></h3>
                  <p>
                    El Lloc web pot emprar cookies o tecnologies similars que es regiran
                    pel que s'estableix en la
                    <a class="hoverable" href="https://onesbanda.com/politica-cookies/"
                      >Política de Cookies</a
                    >, accessible en tot moment i respectant la confidencialitat i intimitat
                    de l'usuari, sent part integrant del present Avís Legal.
                  </p>
                  <h3><strong>Navegació:</strong></h3>
                  <p>
                    Els servidors d'Internet poden recollir dades no identificables, que
                    puguen incloure, adreces IP, i altres dades que no poden ser utilitzats
                    per a identificar a l'usuari. La seua adreça IP s'emmagatzemarà en els *logs d'accés
                    de manera automàtica i amb l'única finalitat de permetre el
                    trànsit per Internet, sent necessari que el seu equip facilite aquesta
                    adreça IP quan navega per Internet perquè les comunicacions puguen
                    realitzar-se. Així mateix, l'adreça IP podrà ser utilitzada per a realitzar
                    estadístiques, de manera anonimitzada, sobre el nombre de visitants d'aquesta
                    web i la seua procedència, de forma totalment transparent a la seua navegació.
                  </p>
                  <h3><strong>Propietat intel·lectual i industrial:</strong></h3>
                  <p>
                    L'usuari coneix i accepta que tots els continguts i/o qualssevol altres
                    elements del lloc web són propietat de <strong>ONES</strong>, i es compromet
                    a respectar els drets de propietat intel·lectual i industrial
                    titularitat de <strong>ONES</strong>. Qualsevol ús de la web o els seus
                    continguts haurà de tindre un caràcter exclusivament particular.
                  </p>
                  <p>
                    Està reservat exclusivament a <strong>ONES</strong>, qualsevol altre ús
                    que supose la còpia, reproducció, distribució, transformació,
                    comunicació pública o qualsevol altra acció similar, de tot o part dels
                    continguts de la web, per la qual cosa cap usuari podrà dur a terme
                    aquestes accions sense l'autorització prèvia i per escrit de
                    <strong>ONES.</strong>
                  </p>
                  <h3><strong>Legislació aplicable i jurisdicció competent:</strong></h3>
                  <p>
                    El present Avís Legal s'interpretarà i regirà de conformitat amb la
                    legislació espanyola. <strong>Vicent Mayans Roca (ONES)</strong> i els
                    usuaris, amb renúncia expressa a qualsevol altre fur que poguera
                    correspondre'ls, se sotmeten al dels jutjats i tribunals del domicili
                    de l'usuari per a qualsevol controvèrsia que poguera derivar-se de l'accés o
                    ús de la web. En el cas que l'usuari tinga el seu domicili fora d'Espanya,
                    <strong>Vicent Mayans Roca (ONES)</strong> i l'usuari,
                    se sotmeten, amb renúncia expressa a qualsevol altre fur, als
                    jutjats i tribunals del domicili de la Comunitat
                    Valenciana.
                  </p>`,
  textPoliticaPrivacitat: `<h1>POLÍTICA DE PRIVACITAT</h1>
                          <p>
                            Segons el que s'estableix en el RGPD (Reglament (UE) 2016/679), els
                            proporcionem la Informació Detallada de Protecció de Dades que s'exposa
                            a continuació:
                          </p>
                          <h3><strong>Responsable:</strong></h3>
                          <p>
                            Raó Social: Vicent Mayans Roca<br />NIF: 20845345P<br />Adreça: Plaça
                            del Regne, 5, 46600 Alzira, Valencia<br />Teléfono:
                            <a class="hoverable" href="tel:+34618118469">+34 618118469</a><br />Correu
                            electrònic:
                            <a class="hoverable" href="mailto:info{'@'}onesbanda.com">info{'@'}onesbanda.com</a>
                          </p>
                          <h3><strong>Finalitat:</strong></h3>
                          <p>
                            L'informem que les Dades de Caràcter Personal recollits, seran
                            incorporats a un Fitxer sota la nostra responsabilitat, amb la finalitat
                            de gestionar l'enviament de la informació que ens sol·liciten i facilitar als
                            interessats ofertes de productes i serveis del seu interés (així com
                            realitzar la facturació dels productes adquirits en la nostra Pàgina
                            Web). Les dades proporcionades es conservaran mentre es mantinga la
                            relació comercial, durant els anys necessaris per a complir amb les
                            obligacions legals o se sol·licite la seua supressió per l'interessat.
                          </p>
                          <h3><strong>Legitimació:</strong></h3>
                          <p>
                            Les Dades de Caràcter Personal obtinguts en aquesta Pàgina Web, així com l'oferta
                            de productes i serveis oferits, està basada en el
                            consentiment que se li sol·licita a l'interessat.
                          </p>
                          <p>
                            L'interessat tindrà dret a retirar el seu consentiment en qualsevol
                            moment. La retirada del consentiment no afectarà la licitud del
                            tractament basada en el consentiment previ a la seua retirada.
                          </p>
                          <h3><strong>Destinataris:</strong></h3>
                          <p>No se cediran dades a tercers, excepte obligació legal.</p>
                          <h3><strong>Drets:</strong><br /></h3>
                          <p>
                            Vosté com a interessat directe, té dret a obtindre confirmació sobre
                            si en <strong>ONES</strong> estem tractant dades personals que el
                            concerneixen, o no. Vosté té dret a accedir a les seues dades personals,
                            així com a sol·licitar la rectificació de les dades inexactes o, en el seu cas
                            , sol·licitar la seua supressió quan, entre altres motius, les dades ja no
                            siguen necessaris per als fins que van ser recollits.
                          </p>
                          <p>
                            En determinades circumstàncies, vosté podrà sol·licitar la limitació del
                            tractament de les seues dades, i en aquest cas únicament els conservarem per a l'exercici
                            o la defensa de reclamacions.
                          </p>
                          <p>
                            En determinades circumstàncies i per motius relacionats amb la seua situació
                            particular, vosté podrà oposar-se al tractament de les seues dades.
                            <strong>ONES</strong>
                            deixarà de tractar les dades, excepte per motius legítims imperiosos, o l'exercici
                            o la defensa de possibles reclamacions.
                          </p>
                          <p>
                            En determinades circumstàncies, vosté tindrà dret a rebre les dades
                            personals que li incumbisquen i que ens haja facilitat, i transmetre'ls o
                            sol·licitar que li'ls proporcionem a un tercer sense objecció per part nostra
                            (dret a la portabilitat de dades).
                          </p>
                          <p>
                            En determinades circumstàncies, l'informem que tindrà dret a no ser
                            objecte d'una decisió basada únicament en el tractament automatitzat,
                            inclosa l'elaboració de perfils, que produïsca efectes jurídics sobre
                            vosté o l'afecte significativament de manera similar.
                          </p>
                          <p>
                            Si necessites qualsevol aclariment sobre aquest tema, per favor, no dubtes a
                            contactar-nos a través del correu
                            <a class="hoverable" href="mailto:info{'@'}onesbanda.com">info{'@'}onesbanda.com</a>
                          </p>`,
  textPoliticaCookies: `<h1>POLÍTICA DE COOKIES</h1>
                        <p><strong>Què son les cookies?</strong></p>
                        <p>
                          Una cookie és un fitxer que es descarrega en el seu ordinador en accedir a
                          determinades pàgines web. Les cookies permeten a una pàgina web, entre
                          altres coses, emmagatzemar i recuperar informació sobre els hàbits de
                          navegació d'un usuari o del seu equip i, depenent de la informació
                          que continguen i de la forma en què utilitze el seu equip, poden utilitzar-se
                          per a reconéixer a l'usuari.
                        </p>
                        <p><strong>Quins tipus de cookies utilitza aquesta pàgina web?</strong></p>
                        <ul>
                          <li>
                            Cookies pròpies: Són aquelles que s'envien a l'equip terminal de l'usuari
                            des d'un equip o domini gestionat pel propi editor i
                            des del qual es presta el servei sol·licitat per l'usuari.
                          </li>
                          <li>
                            Cookies de tercers: Són aquelles que s'envien a l'equip terminal de l'usuari
                            des d'un equip o domini que no és gestionat per l'editor,
                            sinó per una altra entitat que tracta les dades obtingudes través de les
                            cookies.
                          </li>
                          <li>
                            Cookies de sessió: Són un tipus de cookies dissenyades per a recaptar i
                            emmagatzemar dades mentre l'usuari accedeix a una pàgina web.
                          </li>
                          <li>
                            Cookies persistents: Són un tipus de cookies en el qual les dades segueixen
                            emmagatzemats en el terminal i poden ser accedits i tractats durant un
                            període definit pel responsable de la *cookie, i que pot anar d'uns
                            minuts a diversos anys.
                          </li>
                          <li>
                            Cookies d'anàlisi: Són aquelles que ben tractades per nosaltres o per
                            tercers, ens permeten quantificar el nombre d'usuaris i així realitzar
                            el mesurament i anàlisi estadística de la utilització que fan els
                            usuaris del servei oferit. Per a això s'analitza la seua navegació en
                            la nostra pàgina web amb la finalitat de millorar l'oferta de productes o
                            serveis que li oferim.
                          </li>
                        </ul>
                        <p><strong>Com gestionar les cookies?</strong></p>
                        <p>
                          Vosté pot permetre, bloquejar o eliminar les cookies instal·lades en el seu
                          equip mitjançant la configuració de les opcions del navegador instal·lat
                          en el seu ordinador, en cas que no permeta la instal·lació de cookies en el seu
                          navegador és possible que no puga accedir a alguna de les seccions de
                          la nostra web.
                        </p>`,
};
